export enum AuditableEntityType {
  None,
  Delinquency,
  Renewal,
  WorkflowStep,
  TurnoverData,
}
